/** Unique identifiers for every modal dialog in the dashboard, used by the modal slice. */
export enum ModalId {
  UPDATE_CIG_NOTE_CONFIRMATION_DIALOG = "update-cig-note-confirmation-dialog",
  NAR_LETTER_MODAL = "nar-letter-modal",
  INSURANCE_ERROR_DIALOG = "insurance-error-dialog",
  IMAGE_VIEWER_MODAL = "image-viewer-modal",
  BO_VALUES_MODAL = "bo-values-modal",
  STATUS_UPDATE_MODAL = "status-update-modal",
  DOC_VIEWER_MODAL_WITH_TITLE = "doc-viewer-modal-with-title",
  DOC_VIEWER_MODAL = "doc-viewer-modal",
  DOC_VIEWER_WITH_SIDE_NAVIGATION = "doc-viewer-with-side-navigation",
  AUTH_INACCURACY_MODAL = "auth-inaccuracy-modal",
  FINAL_DOCUMENT_MODAL = "documents-modal",
  FORM_SELECTION_MODAL = "form-selection-modal",
  ANALYTICS_DATE_PICKER_MODAL = "analytics-date-picker-modal",
  API_RESPONSE_VIEWER_MODAL = "api-response-viewer-modal",
  TRIGGER_RPA_MODAL = "trigger-rpa-modal",
  TRIGGER_RPA_MODAL_NEW = "trigger-rpa-modal-new",
  COMMENTS_WRITEBACK_VALIDATION_MODAL = "comments-writeback-validation-modal",
  COMMENT_RPA_MODAL_NEW = "comment-rpa-modal-new",
  STATUS_CHANGED_TO_HOLD_MODAL = "status-changed-to-hold-modal",
  HAPPY_FLOW_MODAL = "happy-flow-modal",
  CLINICAL_DATA_TABLE = "clinical-data-table",
  NAR_GRID_MODAL = "nar-grid-modal",
  TRIGGER_RPA_WITH_DOC_LIST_MODAL = "trigger-rpa-with-doc-list-modal",
  NAR_RPA_TRIGGER_MODAL = "nar-rpa-trigger-modal",
  IMAGE_VIEWER_WITH_BADGES_MODAL = "image-viewer-with-badges-modal",
  TOGGLE_SWITCH_CONFIRMATION_DIALOG = "toggle-switch-confirmation-dialog",
  AGENTIC_AUTH_ON_FILE_TOGGLE_DIALOG = "agentic-auth-on-file-toggle-dialog",
  AGENTIC_AUTH_ON_FILE_ADD_PAYER_MODAL = "agentic-auth-on-file-add-payer-modal",
  ORDER_PROCESSING_INFO_MODAL = "order-processing-info-modal",
  DRAFT_SUBMISSION_MODAL = "draft-submission-modal",
  REVIEW_MODAL = "review-modal",
  VIEW_REVIEW_MODAL = "view-review-modal",
  NAR_INGESTION_UPLOAD_MODAL = "nar-ingestion-upload-modal",
  NAR_INGESTION_RE_UPLOAD_MODAL = "nar-ingestion-re-upload-modal",
  PAGE_LEAVE_CONFIRMATION_MODAL = "page-leave-confirmation-modal",
  ADD_NEW_VIEW_TAB = "add-new-view-tab-modal",
  // Options Configuration
  AUTH_OPTIONS_MODAL = "auth-options-modal",
  AUTH_OPTIONS_DELETE_MODAL = "auth-options-delete-modal",
  BO_OPTIONS_MODAL = "bo-options-modal",
  BO_OPTIONS_DELETE_MODAL = "bo-options-delete-modal",
  AUTHORIZATION_LETTER_ADD_VALUE_MODAL = "authorization-letter-add-value-modal",
  OPTIONS_REORDER_MODAL = "reorder-modal",
  DOCUMENT_SCREENSHOT_VIEWER_MODAL = "document-screenshot-viewer-modal",
  EVBV_MODAL = "evbv-modal",
  BULK_REASSIGN_MODAL = "bulk-reassign-modal",
  ADD_NEW_DX_MODAL = "add-new-dx-modal",
  CREATE_TASK_MODAL = "create-task-modal",
  LINK_EXISTING_TASK_MODAL = "link-existing-task-modal",
  LINK_EXISTING_TASK_CONFIRM_MODAL = "link-existing-task-confirm-modal",
  TASK_CONVERSATION_COMPLETE_CONFIRM_MODAL = "task-conversation-complete-confirm-modal",
  TASK_PDF_VIEWER_MODAL = "task-pdf-viewer-modal",
  APPROVE_EVBV_MODAL = "approve-evbv-modal",
  CPT_NEW_DESCRIPTION_MODAL = "cpt-new-description-modal",
  AUTH_LETTER_UPLOAD_MODAL = "auth-letter-upload-modal",
  AUTH_LETTER_SUCCESS_MODAL = "auth-letter-success-modal",
  DELETE_CONFIRMATION_MODAL = "delete-confirmation-modal",
  ADD_NEW_CPT_CODE_MODAL = "add-new-cpt-code-modal",
  RADIO_SELECT_MODAL = "radio-select-modal",
  HISTORIC_NAR_CONFIRM_SOURCE_MODAL = "historic-nar-confirm-source-modal",
  NEEDS_REVIEW_MODAL = "needs-review-modal",
  // Document Studio
  DOCUMENT_STUDIO_DIFF_MODAL = "document-studio-diff-modal",
  DOCUMENT_STUDIO_CREATE_MODAL = "document-studio-create-modal",
}
